<template>
  <div class="index" id="index">
  <HeaderPage/>
  </div>
</template>

<script>
import HeaderPage from "@/view/HeaderPage";


export default {
  name: "IndexPage",
  components:{
    HeaderPage
  },
}
</script>

<style lang="scss"  scoped>

.index{
  height: calc(100vh - 130px);
  margin-top: 80px;
}

</style>